<div class="routed-container">
    <div class="routed-content justify-center items-center flex flex-col w-full" #routedContainer>
        <div class="typeahead-container flex flex-col w-100 p-15">
            <label>Search Employee</label>
            <app-typeahead class="no-flex" [clearOnItemSelect]="true" [itemTypeID]="'employee'"
                (itemSelected)="handleEmployeeSelect($event)"></app-typeahead>
        </div>
        <a [routerLink]="['/employees/new']" class="fab flex items-center justify-center">
            <i class="material-icons">add</i>
        </a>
    </div>
</div>



<ng-template #addEmployeeModalContent>
    


</ng-template>